<div class="gl-dashboard__header">
  <div class="gl-dashboard__title">
    <span>{{ 'dashboard.widgets.nps.title' | translate }}</span>
    <button
      type="button"
      lmsTooltip
      [tooltipConfig]="{
        positionV: 'top',
        positionH: 'center',
        text: ['dashboard.widgets.nps.description' | translate]
      }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
  <lms-select-dashboard
    [selectionList]="filterList"
    [defaultFilter]="defaultFilter"
    (selectedFilter)="setFilter($event)"
  ></lms-select-dashboard>
</div>
<div class="gl-dashboard__npsInfo">
  <div class="nps-data">
    <div class="nps-data__number" [ngClass]="npsColor">{{ metricNps['ratioNPS'] | number : '1.0-1' }}</div>
  </div>
  <div class="gl-dashboard__npsInfo--indicatorArrow" [ngStyle]="{ right: npsValue + '%' }"></div>
</div>
<div class="gl-dashboard__npsChart">
  <div class="gl-dashboard__npsChart--state">
    <span class="coral"></span>
  </div>
  <div class="gl-dashboard__npsChart--state">
    <span class="green-light nps-30"></span>
    <span class="green nps-40"></span>
    <span class="greeny-blue nps-30"></span>
  </div>
  <span class="gl-dashboard__npsChart--handle" [ngStyle]="{ width: npsValue + '%' }"></span>
</div>
<div class="gl-dashboard__npsChart--values">
  <div>{{ minValue }}</div>
  <span>0</span>
  <div class="nps-improved">
    <span class="nps-30">30</span>
    <span class="nps-70">70</span>
    <span class="nps-100">{{ maxValue }}</span>
  </div>
</div>

<ul class="gl-dashboard__npsChart--legend">
  <li>
    <span class="circle coral"></span>
    <span>{{ 'dashboard.widgets.nps.chart.improve' | translate }}</span>
  </li>
  <li>
    <span class="circle green"></span>
    <span>{{ 'dashboard.widgets.nps.chart.brilliant' | translate }}</span>
  </li>
  <li>
    <span class="circle green-light"></span>
    <span>{{ 'dashboard.widgets.nps.chart.well' | translate }}</span>
  </li>
  <li>
    <span class="circle greeny-blue"></span>
    <span>{{ 'dashboard.widgets.nps.chart.excellent' | translate }}</span>
  </li>
</ul>
